import { hooks } from '@yola/ws-sdk';
import control from './controls/control';
import constants from './constants/common';
import helpers from './helpers';

const { ON_STATIC_DOCUMENT_CONNECTED, ON_BEFORE_INSERT_STATIC_ELEMENT } = hooks.availableHooks;
const { beforeViewLoad, beforeElementInsert } = helpers;

const getExtension = () => {
  hooks.operations.subscribe(ON_STATIC_DOCUMENT_CONNECTED, beforeViewLoad);
  hooks.operations.subscribe(ON_BEFORE_INSERT_STATIC_ELEMENT, beforeElementInsert);

  return {
    slug: constants.slug,
    title: 'WS Google Maps Customizer',
    description: 'Extension for editing google maps',
    settings: {
      querySelector: constants.DEFAULT_QUERY_SELECTOR,
      tagName: constants.TAG_NAME,
      defaultSource: constants.DEFAULT_SOURCE,
      defaultAddress: constants.DEFAULT_ADDRESS,
    },
    ui: {
      control: [control],
    },
  };
};

export default getExtension;
